import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WrenwoodHeader',
  setup(__props) {

const cards = [
	{
		lifestyle: "/assets/images/dxp/prebuilt-headers/wrenwood/bed-lifestyle.jpg",
		textImg: "/assets/images/dxp/prebuilt-headers/wrenwood/bedding-and-blankets.jpg",
		link: "https://www.farmandfleet.com/brands/wrenwood/?categorynew=020608&mode=list",
		aria: "Bedding and Blankets"
	},
	{
		lifestyle: "/assets/images/dxp/prebuilt-headers/wrenwood/towel-lifestyle.jpg",
		textImg: "/assets/images/dxp/prebuilt-headers/wrenwood/bath-and-accessories.jpg",
		link: "https://www.farmandfleet.com/brands/wrenwood/?categorynew=0201&mode=list",
		aria: "Bath and Accessories"
	},
	{
		lifestyle: "/assets/images/dxp/prebuilt-headers/wrenwood/blanket-lifestyle.jpg",
		textImg: "/assets/images/dxp/prebuilt-headers/wrenwood/storage-baskets-and-containers.jpg",
		link: "https://www.farmandfleet.com/brands/wrenwood/?categorynew=021103&mode=list",
		aria: "Storage Baskets"
	}
];

//Attempt to reduce the amount of flashing that happens on load.
function preLoadImages() {
	new Image().src = "/assets/images/dxp/prebuilt-headers/wrenwood/bath-and-accessories.jpg";
	new Image().src = "/assets/images/dxp/prebuilt-headers/wrenwood/bed-lifestyle.jpg";
	new Image().src = "/assets/images/dxp/prebuilt-headers/wrenwood/bedding-and-blankets.jpg";
	new Image().src = "/assets/images/dxp/prebuilt-headers/wrenwood/blanket-lifestyle.jpg";
	new Image().src = "/assets/images/dxp/prebuilt-headers/wrenwood/OnlyAtBlains.png";
	new Image().src = "/assets/images/dxp/prebuilt-headers/wrenwood/storage-baskets-and-containers.jpg";
	new Image().src = "/assets/images/dxp/prebuilt-headers/wrenwood/towel-lifestyle.jpg";
	new Image().src = "/assets/images/dxp/prebuilt-headers/wrenwood/Wrenwood_Logo_W.jpg";
	new Image().src = "/assets/images/dxp/prebuilt-headers/wrenwood/WW-background-pattern.avif";
}

onBeforeMount(() => {
	preLoadImages();
});


return { __sfc: true,cards, preLoadImages }
}

})